import { Field, Float, ObjectType } from 'type-graphql'
import { Company } from './Company'
import { User } from '../user/User'

/**
 * Company with embedded contacts for the enhanced company list view.
 * This type is used by the CompanyListDataService to return companies
 * with their associated contacts already populated.
 */
@ObjectType()
export class CompanyWithContacts extends Company {
  @Field(() => [User], { nullable: true })
  contacts?: User[]

  @Field(() => Float, { nullable: true })
  contactCount?: number
}
